<template>
    <div>
        <div v-if="! cartData.displayItems.length">
            <div class="py-6xl text-center">
                <div class="text-2xl mb-xs">😢</div>
                <div class="text-md font-bold">{{ lang('Du har inga produkter i varukorgen än','Your cart is currently empty') }}.</div>
            </div>
        </div>
        <div v-else>
            <div
                :class="{'mb-4xl': ! dropdown }"
                class="bg-white"
            >
                <cart-items
                    :cart-data="cartData"
                    :dropdown="dropdown"
                    @cartDataUpdated="updateCartData"
                />
            </div>

            <div
                v-if="showDependingOnMessage && cartData.productInCartDependsOnOtherMessage"
                class="container mx-auto"
            >
                <div class="bg-neutral-lighter rounded-lg py-md px-lg flex items-center justify-start md:mx-lg mb-xl">
                    <div class="text-lg mr-lg">
                        <font-awesome-icon icon="info-circle" class="text-lg text-accent-yellow  mr-lg" />
                    </div>
                    <div class="max-w-xs text-sm font-semibold">
                        {{ cartData.productInCartDependsOnOtherMessage }}
                    </div>
                </div>
            </div>

            <div class="full-content order-footer bg-neutral-darker text-white text-sm mt-xl py-lg md:py-xl" :class="{ 'rounded-b': ! dropdown }">
                <div
                    :class="{'container': dropdown }"
                    class="mx-auto flex flex-wrap items-center"
                >
                    <!--Alignment of cart footer items with cart items-->
                    <div v-if="dropdown" class="hidden md:w-1/3 xl:w-2/5 md:inline-flex dropdown" />
                    <div v-if="! dropdown" class="hidden md:inline-flex w-full md:w-1/3 xl:w-2/5" />
                    <div v-if="! dropdown" class="hidden xl:inline-flex w-full xl:w-1/6" />

                    <p class="mb-lg mr-xl md:mb-0 md:mr-0 md:w-1/4 xl:w-1/6">
                        {{ lang('Månadskostnad','Monthly cost') }}
                        <span class="block text-md font-semibold">{{ cartData.totalMonthlyPriceFormatted }}</span>
                    </p>
                    <p class="mb-lg md:mb-0">
                        {{ lang('Engångskostnad','Initial cost') }}
                        <span class="block text-md font-semibold">{{ cartData.totalOneTimePriceFormatted }}</span>
                    </p>
                    <a
                        v-if="dropdown"
                        :href="route('front.order.create')"
                        class="w-full md:w-auto ml-auto btn btn-md is-primary mb-lg md:mb-0 hover:text-neutral-darker"
                    >
                        {{ lang('Till kassan','To checkout') }}
                    </a>
                </div>
            </div>

            <div v-if="broadbandAddonsPageUrl" class="bg-neutral-lighter">
                <div class="container mx-auto py-xl">
                    <p class="mb-0 text-sm font-bold text-neutral-dark">
                        {{ lang('Behöver du starkare wi-fi signal','Do you need a stronger wi-fi signal') }}?
                        <a :href="broadbandAddonsPageUrl" class="link is-blue">{{ lang('Läs mer om vår extender','Read more about our wifi extender') }}</a>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import CartItems from './Partials/CartItems';
    import { find } from 'lodash-es';

    export default {
        components: {
            CartItems,
        },

        props: {
            initialCartData: {
                type: Object,
                required: true,
            },
            dropdown: {
                type: Boolean,
                default: false,
            },
            showDependingOnMessage: {
                type: Boolean,
                default: true,
            },
            broadbandAddonsPageUrl: {
                type: String,
                default: null,
            },
        },

        data() {
            return {
                cartData: this.initialCartData,
            };
        },

        created() {
            EventBus.$on('cartDataUpdated', this.updateCartData);
        },

        methods: {
            updateCartData(newCartDataResponse, cartUpdatedFromLocation) {
                if (newCartDataResponse.cartItemWasRemoved && this.route().current('front.products.*')) {
                    window.location.reload();
                    return;
                } else if (newCartDataResponse.cartValidationStateHasChanged && this.route().current('front.order.create')) {
                    window.location.reload();
                    return;
                }

                this.trackAddedToCart(newCartDataResponse.cartData, cartUpdatedFromLocation);

                this.cartData = newCartDataResponse.cartData;
                this.$emit('updated', newCartDataResponse.cartData);
            },
            trackAddedToCart(newCartData, cartUpdatedFromLocation) {
                const products = [];

                newCartData.displayItems.forEach(item => {
                    if (! this.alreadyExistInCart(item.articleId, this.cartData.displayItems)) {
                        products.push(item.gtmProductData);
                    }
                });

                newCartData.subItems.forEach(item => {
                    if (! this.alreadyExistInCart(item.articleId, this.cartData.subItems)) {
                        products.push(item.gtmProductData);
                    }
                });

                if (products.length) {
                    this.$emit('newProductsAdded', products, cartUpdatedFromLocation);
                }
            },
            alreadyExistInCart(articleId, items) {
                return find(items, item => item.articleId === articleId);
            },
        },
    };
</script>